import React from 'react';
import { motion } from 'framer-motion';
import { Users, TrendingUp, ShieldCheck, Zap } from 'lucide-react';
export function About() {
  const features = [{
    icon: <Users className="w-6 h-6 text-brand-accent" data-id="element-22" />,
    title: 'Works alongside internal teams',
    desc: "We don't replace your staff; we empower them by taking over operational heavy lifting."
  }, {
    icon: <TrendingUp className="w-6 h-6 text-brand-accent" data-id="element-23" />,
    title: 'Supports scaling',
    desc: 'Rapidly expand your capacity without the overhead of traditional hiring cycles.'
  }, {
    icon: <Zap className="w-6 h-6 text-brand-accent" data-id="element-24" />,
    title: 'Performance-based partnership',
    desc: 'Our success is tied directly to yours. We focus on outcomes, not just activities.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-brand-accent" data-id="element-25" />,
    title: 'Embedded business support',
    desc: 'Deep integration into your workflows for seamless, high-trust collaboration.'
  }];
  return <section id="about" className="py-12 lg:py-24 bg-slate-900/50" data-id="element-26">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-27">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-28">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-29">
            <h2 className="text-brand-accent font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4" data-id="element-30">
              The Deskmayte Advantage
            </h2>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white mb-4 sm:mb-6 leading-tight" data-id="element-31">
              Your Strategic <br data-id="element-32" />
              Operational Extension
            </h3>
            <p className="text-base sm:text-lg text-slate-400 mb-6 sm:mb-8 leading-relaxed" data-id="element-33">
              Deskmayte is more than a BPO. We are a strategic partner that
              integrates into your company as an operational extension. We
              handle the complexities of scaling so you can focus on the vision.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 sm:gap-6" data-id="element-34">
              {features.map((f, i) => <div key={i} className="p-5 sm:p-6 rounded-2xl bg-white/5 border border-white/10 hover:border-brand-accent/30 transition-all group" data-id="element-35">
                  <div className="mb-3 sm:mb-4 group-hover:scale-110 transition-transform" data-id="element-36">
                    {f.icon}
                  </div>
                  <h4 className="text-white font-bold mb-1 sm:mb-2 text-sm sm:text-base" data-id="element-37">
                    {f.title}
                  </h4>
                  <p className="text-xs sm:text-sm text-slate-400 leading-relaxed" data-id="element-38">
                    {f.desc}
                  </p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative mt-8 lg:mt-0" data-id="element-39">
            <div className="aspect-square rounded-[2rem] sm:rounded-3xl overflow-hidden border border-white/10 bg-slate-800" data-id="element-40">
              <video autoPlay loop muted playsInline className="w-full h-full object-cover opacity-80" data-id="element-41">
                <source src="https://cdn.magicpatterns.com/uploads/1NWqtHuEmz8uKzzcErx5HG/7707060-sd_640_338_25fps.mp4" type="video/mp4" data-id="element-42" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 p-4 sm:p-8 glass-card rounded-xl sm:rounded-2xl max-w-[180px] sm:max-w-xs" data-id="element-43">
              <p className="text-brand-accent font-bold text-2xl sm:text-3xl mb-1" data-id="element-44">
                100%
              </p>
              <p className="text-white font-medium text-xs sm:text-base" data-id="element-45">
                Integration with your existing tech stack and culture.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}